import React from "react";
import ReactDOM from "react-dom";
//import "./index.css";
import App from "./App";
// import "./assets/old/fonts/AGENCYB.TTF";
// import "./assets/old/fonts/SEGOE_UI_BOLD.ttf";
// import "./assets/old/fonts/SEGOE_UI_REGULAR.ttf";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";

// "This file will run firstly when we launch the application from here our App.js file will be triggered"

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
